import {makeAutoObservable, toJS} from "mobx";

class PriceStore {

    priceData = {}
    totalPriceData = {}
    payStatus = 'pending';


    constructor() {
        makeAutoObservable(this)
    }

    getPriceData() {
        return toJS(this.priceData);
    }

    setPriceData(data) {
        this.priceData = data;
    }

    setTotalPriceData(data) {
        this.totalPriceData = data;
    }

    getTotalPriceData() {
        return toJS(this.totalPriceData);
    }

    readyTopay() {
        this.payStatus = 'ready';
    }

    getStatus() {
        return toJS(this.payStatus);
    }

    initValue() {
        this.priceData = {}
        this.totalPriceData = {}
        this.payStatus = 'pending';
    }

}

let priceStore = new PriceStore();
export default priceStore;